import styled from 'styled-components';

export const RadioWrapper = styled.div`
	margin-top: 5rem;
	background-color: ${({ theme }) => theme.colors.secondaryLight};
	padding: 2rem;
	color: #fff;
`;

export const Wrapper = styled.div``;

export const DragNDrop = styled.div`
	border: 0.2rem dashed #23b2c6;
	box-sizing: border-box;
	border-radius: 1rem;
	cursor: pointer;
`;

export const DragNDropSection = styled.section`
	display: flex;
	align-items: center;
	padding: 2rem;
	svg {
		margin-left: 1.3rem;
	}
`;

export const FileList = styled.div`
	position: relative;
	p {
		margin-bottom: 0px;
		font-family: ${({ theme }) => theme.fonts.ArimoMedium};
		text-overflow: ellipsis;
		overflow: hidden;
	}
	svg {
		width: 19px;
		height: 19px;
		position: absolute;
		right: 16px;
		top: 10px;
		cursor: pointer;
	}
	background-color: ${({ theme }) => theme.colors.grayLight};
	border-radius: 2px;
	padding: 1rem 5rem 1rem 3.3rem;
	margin-top: 1rem;
	width: 100%;
`;

export const FileListContainer = styled.div``;

export const TextSection = styled.div`
	margin-left: 2rem;
	margin-top: 1.5rem;
	p {
		margin-top: 0.5rem;
	}
`;

export const DragNDropInput = styled.input``;

export const DragNDropRoot = styled.div``;

export const ContentWriteUp = styled.textarea`
	margin-top: 2rem;
	width: 100%;
	height: 10rem;
	border: 1px solid #999999;
	padding: 2rem;
`;

export const ContentWriteUpWrapper = styled.div`
	margin-top: 2rem;
	height: 10rem;
`;

export const InstructionsWrapper = styled.div`
	margin-top: 2rem;
	input {
		margin-top: 1rem;
	}
`;

export const StyledErrorMessage = styled.div`
	margin: 0.5rem;
	font-size: 1.4rem;
	color: ${({ theme }) => theme.colors.primaryDark};
`;
